import { Directive, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
  selector: '[mdOutsideClick]',
})
export class OutsideClickDirective {
  constructor(private elementRef: ElementRef) {}

  @Output()
  public mdOutsideClick = new EventEmitter<boolean>();

  @HostListener('document:click', ['$event.target'])
  public onClick(element: HTMLElement) {
    const insideClick = this.elementRef.nativeElement.contains(element);
    if (!insideClick) {
      this.mdOutsideClick.emit(true);
    }
  }
}
